

export interface IMaintenance {
  id: number;
  createdByUserId: number;
  description: string;
  from: string;
  to: string;
  blocksQuotes: boolean;
  lastUpdatedByUserId: number;
  status: AvailableTransitionStatuses;
  availableTransitionStatuses: AvailableTransitionStatuses[];
  created: string;
  updated: string;
}

export interface IMaintenanceWindowParams {
  page: number;
  size: number;
  includePast: boolean;
}

export enum AvailableTransitionStatuses {
  Inprogress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
  Skipped = 'SKIPPED',
  Planned = 'PLANNED',
}

export interface ICreateMaintenanceParams {
  description: string;
  from: string;
  to: string;
  blocksQuotes: boolean;
}



